import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, ChevronDownIcon } from 'lucide-react';
import { images } from '../data/site';
const fade = {
  hidden: {
    opacity: 0,
    y: 18
  },
  show: {
    opacity: 1,
    y: 0
  }
};
export function Hero() {
  return <section id="home" className="relative isolate w-full overflow-hidden bg-ink" data-id="element-273" data-mp="9ip7sz70irub">
      <motion.img src={images.hero} alt="Hold Fast Hauling white Freightliner Cascadia coupled to a white Utility 3000R refrigerated trailer under an American sky" className="absolute inset-0 h-full w-full object-cover object-[62%_center]" initial={{
      scale: 1.08
    }} animate={{
      scale: 1
    }} transition={{
      duration: 1.6,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-274" data-mp="4njrcfwdq5dm" />
      <div className="absolute inset-0" aria-hidden="true" style={{
      background: 'linear-gradient(to right, rgba(11,14,17,0.92) 0%, rgba(11,14,17,0.72) 45%, rgba(11,14,17,0.45) 100%)'
    }} data-id="element-275" data-mp="nbyj55eitnfh" />

      <div className="relative mx-auto flex min-h-[100svh] max-w-[1280px] flex-col justify-center px-6 pb-24 pt-32 lg:px-10" data-id="element-276" data-mp="3j7zhzqi0g6kd">
        <motion.div initial="hidden" animate="show" transition={{
        staggerChildren: 0.06,
        delayChildren: 0.1
      }} className="max-w-4xl" data-id="element-277" data-mp="3o6ar1z0hed1j">
          <motion.p variants={fade} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.28em] text-ice-400" data-id="element-278" data-mp="3e8efx77jni3f">
            <span className="h-px w-8 bg-ice-400" aria-hidden="true" data-id="element-279" data-mp="35audvw1uxhrr" />
            Refrigerated • Food-Grade • Nationwide
          </motion.p>

          <motion.h1 variants={fade} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="mt-7 font-display text-[2.7rem] font-extrabold uppercase leading-[0.95] tracking-tightest text-white sm:text-6xl lg:text-[5.2rem]" data-id="element-280" data-mp="2vi53l4i1m9y0">
            Nationwide
            <br data-id="element-281" data-mp="s2bckbltt7bh" />
            <span className="text-ice-400" data-id="element-282" data-mp="s2tb5evynxmk">Temperature-Controlled</span>
            <br data-id="element-283" data-mp="nb1kz5gpvtwy" />
            Logistics
          </motion.h1>

          <motion.p variants={fade} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="mt-8 font-display text-xl font-semibold tracking-tight text-white sm:text-2xl" data-id="element-284" data-mp="n9i2r9bi38sj">
            Zero Degrees. Zero Hesitation.
          </motion.p>

          <motion.p variants={fade} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="mt-4 max-w-xl text-base leading-relaxed text-white/70" data-id="element-285" data-mp="1ayji7gir3k7b">
            Reliable, food-grade refrigerated transportation built to move critical freight safely and efficiently
            across the United States.
          </motion.p>

          <motion.div variants={fade} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="mt-10 flex flex-wrap items-center gap-4" data-id="element-286" data-mp="3lu9y13eog2ca">
            <a href="#contact" className="group inline-flex items-center gap-2 rounded-full bg-ice px-8 py-4 text-[13px] font-bold uppercase tracking-[0.1em] text-white transition-colors duration-150 ease-premium hover:bg-ice-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-ink" data-id="element-287" data-mp="1xb5pse406rg4">
              Request a Quote
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-premium group-hover:translate-x-1" data-id="element-288" data-mp="2kyvmnfd5fqjq" />
            </a>
            <a href="#services" className="group inline-flex items-center gap-2 rounded-full border border-white/30 px-8 py-4 text-[13px] font-bold uppercase tracking-[0.1em] text-white transition-colors duration-150 ease-premium hover:border-white hover:bg-white/5" data-id="element-289" data-mp="2p1jv3lxyavg6">
              Explore Our Services
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-premium group-hover:translate-x-1" data-id="element-290" data-mp="zndpvcdk9c4u" />
            </a>
          </motion.div>
        </motion.div>
      </div>

      <a href="#about" aria-label="Scroll to learn more" className="absolute bottom-8 left-1/2 z-10 -translate-x-1/2 text-white/70 transition-colors duration-150 ease-premium hover:text-white" data-id="element-291" data-mp="3vjrw2jaii9vr">
        <span className="flex flex-col items-center gap-2" data-id="element-292" data-mp="3hq0rlpbn1g6w">
          <span className="text-[10px] font-semibold uppercase tracking-[0.24em]" data-id="element-293" data-mp="3hqk3opelxad0">Scroll</span>
          <ChevronDownIcon className="animate-scroll-hint h-5 w-5" data-id="element-294" data-mp="3ct0lxfipafgb" />
        </span>
      </a>
    </section>;
}